<template>
  <div class="notification">
    <div class="main">
      <strong class="title">{{ title }}</strong>
      <p class="message">{{ message }}</p>
    </div>
    <div class="actions" v-if="actions">
      <template v-for="action in actions">
        <router-link
          tag="button"
          v-if="action.to"
          :key="action.label"
          :to="action.to"
          class="action"
        >
          {{ action.label }}
        </router-link>
        <button
          v-else
          :key="action.label"
          class="action"
          @click="onClick(action)"
        >
          {{ action.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { actions } from "@/store";

export default {
  props: {
    id: String,
    title: String,
    message: String,
    actions: { type: Array }
  },
  methods: {
    ...mapActions([actions.notificationDismiss]),
    onClick({ action, payload }) {
      if (action) {
        this.$store.dispatch(action, payload);
      }
      this.notificationDismiss({ id: this.id });
    }
  }
};
</script>

<style scoped lang="scss">
.notification {
  --notification-border-color: var(--button-default-border-color);

  display: flex;
  width: 300px;
  margin: 0.5rem 0.5rem 0 0;
  overflow: hidden;
  background: var(--card-background-transparent);
  border: 1px solid var(--notification-border-color);
  border-radius: 0.5rem;
  box-shadow: 0 0 10px var(--shadow-color);
}
.main {
  flex: 1 1 auto;
  padding: 0.5rem;
}
.title {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
}
.message {
  margin: 0.5rem 0 0;
  font-size: 1rem;
  word-break: break-word;
}
.actions {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 80px;
}
.action {
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 1rem;
  color: var(--button-default-text-color);
  background: transparent;
  border: 0;
  border-left: 1px solid var(--notification-border-color);
  border-radius: 0;
  transition-duration: 250ms;
  & + & {
    border-top: 1px solid var(--notification-border-color);
  }
  &:hover {
    background: var(--button-default-hover-background);
  }
}
</style>
